import { Component, OnInit, inject, input } from '@angular/core';
import {UserService} from '../../../../services/user/user.service';
import {EnvironmentService} from '../../../../services/environment.service';
import { UntilDestroy } from 'ngx-unificator/decorator';
import { untilDestroyed } from 'ngx-unificator/rxjs';
import {combineLatest} from 'rxjs';
import {tap} from 'rxjs/operators';
import { CommonDataService } from '../../../../services/common-data.service';
import { CurrencyFormatPipe } from '../../../pipes/currency-format.pipe';

@UntilDestroy()
@Component({
    selector: 'app-jackpot-badge',
    templateUrl: './jackpot-badge.component.html',
    styleUrls: ['./jackpot-badge.component.scss'],
    imports: [CurrencyFormatPipe]
})
export class JackpotBadgeComponent implements OnInit {
  private _user = inject(UserService);
  private _env = inject(EnvironmentService);
  private _data = inject(CommonDataService);


  /**
   * Current game
   */
  readonly game = input<any>({});

  /**
   * Amount jackpot
   */
  public amount: string | number;

  /**
   * Currency for display
   */
  public currency: string;

  /**
   * Currency symbol for display
   */
  public currencySymbol: string;

  ngOnInit() {
    combineLatest([
      this._user.auth$,
      this._env.env$
    ]).pipe(
      untilDestroyed(this),
      tap(([auth, env]) => {
        if(auth) {
          this.currency = this._user.currentCurrency.currency;
          this.amount = this._data.subunitsToUnits(this.game().externalData.real[this._user.currentCurrency.currency].jackpot, this.currency);
        } else {
          this.currency = this.game().externalData.real[this._env.env.currency.short] ? this._env.env.currency.short : 'EUR';
          this.amount = this._data.subunitsToUnits((this.game().externalData.real[this._env.env.currency.short] || this.game().externalData.real['EUR']).jackpot, this.currency);
        }
        this.currencySymbol = this._data.currencySymbol(this.currency);
      })
    ).subscribe();
  }

}
